<div class="header-window">
    <img src="images/logo.png" alt="cloudigo Logo"/>
    @if(collabImage(); as imageSource){
        <p style="margin: 0 8px;">x</p>
        <img [src]="imageSource" alt="Partner Logo"/>
    }
</div>
<div id="portal-window">
</div>